module.exports = __webpack_public_path__ + "static/img/index_user_bg.685498b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/index_user_bg.png
// module id = 3TVI
// module chunks = 1